// src/contexts/UserContext.js
import React, { createContext, useState, useContext, useCallback } from "react";
import { Auth } from "aws-amplify";
import api from "../services/api";
import { API_PATHS } from "../config/apiConfig";
import log from "../utils/logger";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [lastUpdate, setLastUpdate] = useState(Date.now());

  const updateUser = useCallback((newUserData) => {
    setUser((prevUser) => ({ ...prevUser, ...newUserData }));
    setLastUpdate(Date.now());
  }, []);

  const refreshUser = useCallback(async () => {
    try {
      const userData = await Auth.currentAuthenticatedUser();
      setUser(userData.attributes);
      setLastUpdate(Date.now());
      // enrich with the app profile (is_admin drives the header Admin link);
      // Cognito attributes win for name/email, DB flags ride alongside
      try {
        const { data } = await api.get(API_PATHS.USERS.PROFILE);
        setUser((prev) => ({ ...(prev || userData.attributes), is_admin: !!data.is_admin }));
      } catch (e) { /* profile fetch is best-effort; link just stays hidden */ }
    } catch (error) {
      setUser(null);
    }
  }, []);

  return (
    <UserContext.Provider value={{ user, updateUser, refreshUser, lastUpdate }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context;
};
